import { Component, computed, inject } from "@angular/core"
import { Option } from "@app/types/option"
import { AuthenticationService } from "@app/services/authentication/authentication.service"
const { none, match } = Option

@Component({
    selector: 'vco-authentication-view',
    template: `
        <div class="authView">
            {{name()}} 
            <br />
            {{ email() }}
            <br />
            {{ organizationName() }}
        </div>
    `,
    styles: [`
        .authView {
            color: var(--color-background);
            font-weight: bold;
            padding: .2rem;
            margin-left: .2rem;
            margin-right: .8rem;
        }
        :host {
            display: flex;
            gap: .5rem;
            flex: 0 0 auto; 
            margin-left: auto;
        }
    `]
}) export class AuthenticationViewComponent {
    private _authService = inject(AuthenticationService)
    readonly authenticatedUser = this._authService.authenticatedUser

    readonly email = computed(() => {
        const userOption = this.authenticatedUser() ?? none
        return match(userOption, {
            some: auth => auth.summary.email,
            none: () => 'Not authenticated'
        })
    })

    readonly organizationName = computed(() => {
        const userOption = this.authenticatedUser() ?? none
        return match(userOption, {
            some: auth => auth.summary.organizationName,
            none: () => 'No organization'
        })
    })

    readonly name = computed(() => {
        const userOption = this.authenticatedUser() ?? none
        return match(userOption, {
            some: auth => auth.summary.firstName + ' ' + auth.summary.lastName,
            none: () => 'Guest'
        })
    })
}